import { Box, Grid, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import classNames from 'classnames'
import React from 'react'
import { CampaignActionBtn } from './campaign-btn'
import { ColourSchemes } from './campaign-util'

const cardShape = 'polygon(0% 0%, 100% 0%, 100% calc(100% - 25px), calc(100% - 25px) 100%, 0% 100%)'

const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  verticalBannerCtn: {
    width: 280,
    minHeight: 250,
    backgroundColor: ({ bg }) => bg
  },
  verticalBannerTxtCtn: {
    padding: spacing(3.5, 2.75)
  },
  verticalBannerTitle: {
    color: ({ text }) => text,
    marginBottom: spacing(2)
  },
  verticalBannerDescription: {
    color: ({ text }) => text,
    marginBottom: spacing(3)
  },
  verticalBannerImg: {
    width: '100%'
  },
  verticalBannerCard: {
    clipPath: cardShape,
    display: 'flex',
    borderRadius: 0,
    width: 280,
    backgroundColor: ({ bg }) => bg
  },
  verticalBannerEdge: {
    paddingRight: 1,
    paddingBottom: 1,
    clipPath: cardShape,
    width: 280,
    backgroundColor: ({ bg }) => bg
  }
}))

export const VerticalCampaignBanner = ({ campaign }) => {
  const { colourScheme, squareImg, title, body } = campaign || {}
  const { bg, text } = ColourSchemes[colourScheme] || {}
  const classes = useStyles({ bg, text })

  if (!campaign) return null
  return (
    <Box className={classes.verticalBannerEdge}>
      <Grid className={classNames(classes.verticalBannerCtn, classes.verticalBannerCard)} container direction='row'>
        <Grid item xs={12}>
          <img src={squareImg?.imgUrl} className={classes.verticalBannerImg} />
        </Grid>
        <Grid item xs={12} className={classes.verticalBannerTxtCtn}>
          <Typography className={classes.verticalBannerTitle} variant='h5'>{title}</Typography>
          <Typography
            variant='body2'
            className={classes.verticalBannerDescription}
            dangerouslySetInnerHTML={{ __html: body }}
          />
          <CampaignActionBtn campaign={campaign} />
        </Grid>
      </Grid>
    </Box>
  )
}
